module.exports = __webpack_public_path__ + "static/img/8.418a6fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/8.png
// module id = nZBa
// module chunks = 0